import { createActionGroup, props } from '@ngrx/store';
import { CategoryConfigurationInheritanceStructureDto } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';

export const CategoryConfigurationInheritedResolverActions = createActionGroup({
  source: 'Category configuration inherited resolver',
  events: {
    'Category configuration inherited requested': props<{ categoryId: string }>(),
  },
});

export const CategoryConfigurationInheritedApiActions = createActionGroup({
  source: 'Category configuration inherited API',
  events: {
    'Category configuration inherited requested': props<{ categoryId: string }>(),
    'Category configuration inherited loaded': props<{ configuration: CategoryConfigurationInheritanceStructureDto }>(),
    'Category configuration inherited loaded error': props<{ error: ErrorModel }>(),
  },
});
